
import { Component, Mixins, Watch } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../system/mixins";
import { default as DocumentAttributesEditableMixin } from "./DocumentAttributesEditableMixin.vue";
import { default as DocumentStructureEditableMixin } from "./DocumentStructureEditableMixin.vue";
import { default as ExtraInformationUpdatableMixin } from "./ExtraInformationUpdatableMixin.vue";
import { default as DocumentPageNavigatableMixin } from "./DocumentPageNavigatableMixin.vue";

// Mixinsの引数5個以上は可変長パラメータのオーバーロード実装を利用するが、
// ジェネリクス型が類推されないのでジェネリクス型を交差型として明示的に指定する事.
// (詳細はMixinsの実装を確認してください.F12で飛べます.引数5個の実装と可変長パラメータの実装を比較してみてください.)
@Component
export default class DocumentEditableMixin extends Mixins<
  ModelEditableMixin
  & DocumentAttributesEditableMixin
  & DocumentStructureEditableMixin
  & ExtraInformationUpdatableMixin
  & DocumentPageNavigatableMixin
>(
  ModelEditableMixin,
  DocumentAttributesEditableMixin,
  DocumentStructureEditableMixin,
  ExtraInformationUpdatableMixin,
  DocumentPageNavigatableMixin,
) {
  private changeToBrowsed(): void {
    if (this.currentSectionIndex < 0) { return; }
    if (!this.sections[this.currentSectionIndex].hasBeenBrowsed) {
      this.sections[this.currentSectionIndex].hasBeenBrowsed = true;
    }
  }

  @Watch("currentPage")
  onEditableDocumentCurrentPageChanged() {
    // 閲覧済みページにする
    this.changeToBrowsed();
  }
}
